module.exports = __webpack_public_path__ + "img/companySM.bad35d6f.png";